export default "__VITE_ASSET__384e57fd__"